<template>
    <div class="hostStuff showTabs secondary-color d-flex headerTab openHeader" @click.stop="">
        <div class="leftBar">
            <ul>
                <li :class="(profilePop == 'profile')?'active':' '">
                    <a @click="profilePop = 'profile' " class="d-flex align-items-center f-12" href="#"><feather class="mr-2" size="18px" type="user"></feather>{{$t('profile') }} </a>
                </li>
                <li :class="(profilePop == 'security')?'active':' '">
                    <a @click="profilePop = 'security' " class="d-flex align-items-center f-12" href="#"><feather class="mr-2" size="18px" type="lock"></feather>{{$t('security') }} </a>
                </li>
                <li :class="(profilePop == 'change-password')?'active':' '">
                    <a @click="profilePop = 'change-password' " class="d-flex align-items-center f-12" href="#"><feather class="mr-2" size="18px" type="key"></feather>{{$t('change_password') }}</a>
                </li>
            </ul>
        </div>
        <div class="dhowRight-tabs position-relative" v-if="profilePop == 'profile'">
            <span class="closePOP" @click.stop="close()"><feather size="13px" type="x"></feather></span>
            <div class="formRow headerID d-flex align-items-center border-bottom">
                <span class="profileInfo userClick f-14 justify-content-center align-items-center">
                    <span class="rounded-circle">
                        <span v-if="profileData.FIRSTNAME">{{profileData.FIRSTNAME.charAt(0).toUpperCase()}}</span>
                        <span v-else-if="profileData.EMAIL">{{profileData.EMAIL.charAt(0).toUpperCase()}}</span>
                    </span>
                    <!-- <img src="https://dev.finvasia.com:6020/api/get/user/avatar?user=25&img=gurpreet_ava.png" alt="User" class="rounded-circle"/> -->
                </span>
                <div>
                    <div class="d-flex align-items-center mb-3">
                        <h4 class="f-14">{{$t('username') }} :</h4>
                        <p class="m-0 f-12">{{ (get_user.username || '').split('$$')[1] || '-' }}</p>
                    </div>
                    <div class="d-flex align-items-center">
                        <h4 class="f-14">{{$t('account_id') }} :</h4>
                        <p class="m-0 f-12">{{ get_user.profile.act_account_id || '-'}}</p>
                    </div>
                </div>
            </div>
            <div class="editableField">
                <div class="formRow d-flex align-items-center justify-content-between border-bottom">
                    <div class="leftP">
                        <p class="f-12 mb-0">{{$t('name') }} </p>
                        <span class="sm">{{((profileData.FIRSTNAME||'') + ' ' + (profileData.LASTNAME || '')).trim() || '-'}}</span>
                    </div>
                    <!-- <div class="rightP" :class="setUpFxaccount?'active':' '">
                        <a @click="setUpFxaccount = !setUpFxaccount" href="#">UPDATE</a>
                        <div class="updateField">
                            <div class="innerFixPOp-up">
                                <span class="closePOP" @click="setUpFxaccount = ''"><feather size="13px" type="x"></feather></span>
                                <p class="f-16 text-center mb-5">Update Name</p>
                                <form class="updateWrap">
                                    <div class="form-fields d-flex align-items-center mb-3">
                                        <input type="text" placeholder="first Name" name="">
                                    </div>
                                    <div class="form-fields d-flex align-items-center">
                                        <input type="text" placeholder="Last Name" name="">
                                    </div>
                                    <div class="fullWidh w-100 text-center mt-4">
                                        <a href="#" class="btn appButton greenBG mx-auto justify-content-center uppercase">UPdate</a>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div class="formRow d-flex align-items-center justify-content-between border-bottom">
                    <div class="leftP">
                        <p class="f-12 mb-0">{{$t('email_address') }} </p>
                        <span class="sm">{{profileData.EMAIL || '-'}}</span>
                    </div>
                    <div class="rightP">
                        <!-- <a href="#">UPDATE</a> -->
                    </div>
                </div>
                <!-- <div class="formRow d-flex align-items-center justify-content-between border-bottom">
                    <div class="leftP">
                        <p class="f-12 mb-0">Phone Number</p>
                        <span class="sm">+91 9876 543 210</span>
                    </div>
                    <div class="rightP">
                        <a href="#">UPDATE</a>
                    </div>
                </div> -->
                <div class="formRow d-flex align-items-center justify-content-between">
                    <div class="leftP">
                        <p class="f-12 mb-0">{{$t('currency') }} </p>
                        <span class="sm">{{accountList.Currency || '-'}}</span>
                    </div>
                    <!-- <div class="rightP">
                        <a href="#">UPDATE</a>
                    </div> -->
                </div>
            </div>
        </div>
        <two-fa v-if="profilePop == 'security'"></two-fa>
        <div class="dhowRight-tabs position-relative" v-if="profilePop == 'change-password'">
            <app-loader v-if="pageLoader"/>
            <span class="closePOP" @click.stop="close()"><feather size="13px" type="x"></feather></span>
            <div class="formRow pt-5">
                <div class="midForm">
                    <p class="f-16 text-center mb-5">{{$t('change_password') }}</p>
                    <form class="updateWrap left-0" @submit.prevent=""><!-- changePassword() -->
                        <div class="form-fields mb-4" :class="[{'validation-error':submitted && errors.has('old_password')}]">
                            <div class="position-relative iconInput">
                                <input :type="(showPass1)?'text':'password'" :placeholder="$t('enter_old_password')"v-model="old_password" v-validate="'required||max:20'" ref="old_passwordInput" name="old_password" maxlength="20" /> 
                                <feather :type="(showPass1)?'eye':'eye-off'" @click="showPass1 = !showPass1"></feather>
                            </div>
                            <span class="text-danger-error" v-if="submitted" v-for="error in errors.collect('old_password')">
                                <span class="text-danger" v-show="submitted && error == 'The old_password field is required'">
                                    {{$t('old_password_validation') }} </span>
                                <span class="text-danger" v-show="submitted && error == 'The old_password field may not be greater than 20 characters'">{{$t('old_password_greater_characters') }} </span>
                            </span>
                        </div>
                       
                        <div class="form-fields mb-4" :class="[{'validation-error':submitted && errors.has('new_password')}]">
                            <div class="position-relative iconInput">
                                <input :type="(showPass2)?'text':'password'" :placeholder="$t('enter_new_password')" v-model="new_password" v-validate="{ required: true,regex: /^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*/])\S{6,15}$/}" ref="new_passwordInput" name="new_password" maxlength="20"/><!-- (?=.*[A-Z]) -->
                                <feather :type="(showPass2)?'eye':'eye-off'" @click="showPass2 = !showPass2"></feather>
                            </div>
                            <span class="text-danger-error" v-if="submitted" v-for="error in errors.collect('new_password')">
                            <span class="text-danger" v-show="submitted && error == 'The new_password field is required'">
                                {{$t('new_password_validation') }} </span>
                            <span class="text-danger" v-show="submitted &&error == 'The new_password field format is invalid'">{{$t('password_validation') }} </span>
                        </span>
                        </div>
                        
                        <div class="form-fields" :class="[{'validation-error':submitted && errors.has('confirm_password')}]">
                            <div class="position-relative iconInput">
                                <input :type="(showPass3)?'text':'password'" :placeholder="$t('enter_new_password_again')" v-model="confirm_password" v-validate="{ required: true, confirmed:new_password}" ref="confirm_passwordInput" name="confirm_password" maxlength="20"/>
                                <feather :type="(showPass3)?'eye':'eye-off'" @click="showPass3 = !showPass3"></feather>
                            </div>
                            <span class="text-danger-error" v-if="submitted" v-for="error in errors.collect('confirm_password')">
                                <span class="text-danger" v-show="submitted && error == 'The confirm_password field is required'">{{$t('confirm_password_is_required') }} </span>
                                <span class="text-danger" v-show="submitted && error == 'The confirm_password confirmation does not match'">{{$t('entered_password_not_match') }} </span>
                            </span>
                        </div>
                        
                        <div class="fullWidh w-100 text-center mt-5">
                            <button href="#" class="btn appButton greenBG mx-auto justify-content-center uppercase" @click.stop="changePassword()">{{$t('change_password') }} </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { commonAllmixins } from '@/plugins/commonAll'
import two_FA from '../../user/Two-FA'
import { mapActions } from 'vuex'
import * as types from '@/types'
export default {
    name: 'sideBar-profile',
    mixins: [commonAllmixins],
    data() {
        return {
            pageLoader : false,
            profilePop: 'profile',
            // change-password
            showPass1: false,
            showPass2: false,
            showPass3: false,
            old_password: '',
            new_password: '',
            confirm_password: '',
            submitted: false,
        }
    },
    components:{
        TwoFa : two_FA
    },
    methods:{
        clearAll(){
            this.showPass1 = false
            this.showPass2 = false
            this.showPass3 = false
            this.old_password = ''
            this.new_password = ''
            this.confirm_password = ''
            this.submitted = false
        },
        /*...mapActions({
            _runChangePassword: types.RUN_CHANGE_PASSWORD
        }),*/
        changePassword(){
            const _that = this
            _that.submitted = true;
            // console.log(_that.$store)
            _that.$validator.validate().then(valid => {
                if (valid) {
                    let input_json={
                        'globalParams' :{
                            'old_password' : _that.old_password ,
                            'new_password' : _that.new_password,
                            'confirm_password' : _that.confirm_password,
                        },
                        'localParams' :{ "parameter" : _that }
                    }
                    _that.$store.dispatch(types.RUN_CHANGE_PASSWORD,input_json)
                    // _that._runChangePassword(input_json)
                }/*else{
                    _that.handleValidationErrorAdvanced(_that.errors)
                }*/
            });
        },
        close(){
            this.$parent.$parent.headerTab = ''
            this.$parent.$parent.openHeader = false
        }
    },
    created(){
    }
    
}
</script>





// WEBPACK FOOTER //
// src/components/website/shared/sidebar-popup/profile.vue